import React from 'react'
import "./styles/Company.css"

function Company() {
  return (
    <div className='company' id='About'>
            <h1>About Us</h1>
            <p>At PlanForge, we believe every business deserves a meticulously crafted plan for success. Our expert team provides feasibility studies, econometric and data analysis, and comprehensive training and workshops in economics, marketing, and management. We tailor our services to each client's unique needs, ensuring every plan is actionable, realistic, and aligned with their vision. We conduct all our studies according to international standards. Our proven track record, attention to detail, and commitment to client success make us a trusted partner. We are passionate about empowering businesses to thrive through solid, well-crafted plans</p>
    </div>
  )
}

export default Company